<template>
  <div>
    <v-container>
      <div style="width: 100%">
        <div>
          <v-btn @click="showCategory = true" small color="primary" icon outline>
            <span class="fa fa-pencil-alt"></span>
          </v-btn>
        </div>
        <select-category @onChangeCategory="onChangeCategory" v-model="categorylist"></select-category>
      </div>
      <categories
        v-model="categorylist"
        @close="showCategory = false"
        :show="showCategory"
        @onCategoryChange="onCategoryChange"
      ></categories>
      <div>
        <div @click="showAddReward = true" class="add-product">
          <i class="fa fa-plus middle mr-1"></i> Add reward
        </div>
        <v-dialog v-model="showAddReward" width="550px" persistent>
          <v-card>
            <v-card-text>
              <div class="text-xs-right">
                <v-btn @click="closeform" icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <v-layout row wrap>
                <v-flex xs12 class="pa-1" :class="{'has-error': errors.has('Category')}">
                  <label>{{$t('Category')}}</label>
                  <multiselect
                    return="id"
                    :data-vv-as="$t('Category')"
                    v-validate="'required'"
                    name="Category"
                    v-model="input.categoryid"
                    :options="categorylist"
                    :searchable="false"
                    label="name"
                    :close-on-select="true"
                    :show-labels="false"
                  ></multiselect>
                  <span
                    class="text-error"
                    v-if="errors.has('Category')"
                  >{{ errors.first('Category') }}</span>
                </v-flex>
                <v-flex xs12 class="form-control pa-1" :class="{'has-error': errors.has('Name')}">
                  <label>{{$t('Name')}}</label>
                  <input
                    :data-vv-as="$t('Name')"
                    v-validate="'required'"
                    name="Name"
                    v-model="input.name"
                    class="form-control"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('Name')">{{ errors.first('Name') }}</span>
                </v-flex>
                <v-flex
                  xs12
                  class="form-control pa-1"
                  :class="{'has-error': errors.has('description')}"
                >
                  <label>{{$t('Description')}}</label>
                  <input
                    :data-vv-as="$t('Description')"
                    v-validate="'required'"
                    name="description"
                    v-model="input.description"
                    class="form-control"
                    type="text"
                  />
                  <span
                    class="text-error"
                    v-if="errors.has('description')"
                  >{{ errors.first('description') }}</span>
                </v-flex>
                <v-flex xs6 class="form-control pa-1" :class="{'has-error': errors.has('point')}">
                  <label>{{$t('Point')}}</label>
                  <input
                    :data-vv-as="$t('Point')"
                    v-validate="'required'"
                    name="point"
                    v-model="input.point"
                    class="form-control"
                    type="number"
                  />
                  <span class="text-error" v-if="errors.has('point')">{{ errors.first('point') }}</span>
                </v-flex>
                <v-flex
                  xs6
                  class="form-control pa-1"
                  :class="{'has-error': errors.has('Quantity')}"
                >
                  <label>{{$t('Quantity')}}</label>
                  <input
                    :data-vv-as="$t('Quantity')"
                    v-validate="'required'"
                    name="Quantity"
                    v-model="input.quantity"
                    class="form-control"
                    type="number"
                  />
                  <span
                    class="text-error"
                    v-if="errors.has('Quantity')"
                  >{{ errors.first('Quantity') }}</span>
                </v-flex>
                <v-flex
                  xs6
                  class="form-control pa-1"
                  :class="{'has-error': errors.has('startdate')}"
                >
                  <label>{{$t('Start Date')}}</label>
                  <v-menu
                    ref="menuRef"
                    v-model="showstartdate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template v-slot:activator="{ on }">
                      <input
                        placeholder="dd/mm/yyyy"
                        type="text"
                        name="startdate"
                        :data-vv-as="$t('Start Date')"
                        v-validate="'required'"
                        v-model="filteredStartdate"
                        v-on="on"
                        readonly
                      />
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="input.startdate"
                      @input="showstartdate = false"
                    ></v-date-picker>
                  </v-menu>

                  <span
                    class="text-error"
                    v-if="errors.has('startdate')"
                  >{{ errors.first('startdate') }}</span>
                </v-flex>
                <v-flex xs6 class="form-control pa-1" :class="{'has-error': errors.has('enddate')}">
                  <label>{{$t('End Date')}}</label>
                  <v-menu
                    ref="menuRef"
                    v-model="showenddate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template v-slot:activator="{ on }">
                      <input
                        placeholder="dd/mm/yyyy"
                        type="text"
                        name="enddate"
                        v-validate="'required'"
                        :data-vv-as="$t('End Date')"
                        v-model="filteredEnddate"
                        v-on="on"
                        readonly
                      />
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="input.enddate"
                      @input="showenddate = false"
                    ></v-date-picker>
                  </v-menu>

                  <span
                    class="text-error"
                    v-if="errors.has('enddate')"
                  >{{ errors.first('enddate') }}</span>
                </v-flex>

                <v-flex xs12 class="form-control pa-1" :class="{'has-error': errors.has('Image')}">
                  <label>{{$t('Image')}}</label>
                  <uploadfile v-validate="'required'" name="Image" v-model="input.photourl"></uploadfile>
                  <span class="text-error" v-if="errors.has('Image')">{{ errors.first('Image') }}</span>
                </v-flex>
              </v-layout>
              <div>
                <v-btn
                  v-if="input.id"
                  :loading="saveproductloading"
                  @click="updateproduct"
                  block
                  depressed
                  color="primary"
                >update</v-btn>
                <v-btn
                  v-else
                  :loading="saveproductloading"
                  @click="saveproduct"
                  block
                  depressed
                  color="primary"
                >save</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <div
          v-for="item in filteredProducts"
          :key="item.id"
          style="border: solid 1.5px #ff706b;border-radius: 10px;position:relative"
          class="my-1"
        >
          <div class="text-xs-right" style="position: absolute; right: 10px;top:10px;z-index:3">
            <v-btn @click="editProduct(item)" class="ma-1" icon outline small color="primary">
              <span class="fa fa-pencil-alt"></span>
            </v-btn>
            <v-btn
              :loading="deleteLoading"
              @click="deleteProduct(item)"
              class="ma-1"
              icon
              outline
              small
              color="primary"
            >
              <span class="fa fa-trash-alt"></span>
            </v-btn>
          </div>
          <v-layout row wrap class="ma-0">
            <v-flex xs4 class="pa-2">
              <div
                style=" text-align: center;
                          display: flex;
                          justify-content: center;
                          border-radius:5px;
                          align-items: center;"
              >
                <v-img style="border-radius:15px;" width="40px" :src="item.photourl"></v-img>
              </div>
            </v-flex>
            <v-flex xs8 class="pa-3" style="position: relative">
              <div class="headline">{{item.name}}</div>
              <div>Description: {{item.description}}</div>
              <div>Quantity: {{item.quantity}}</div>
              <div>Start Date: {{item.startdate|dateFormat('DD/MM/YYYY')}}</div>
              <div>End Date: {{item.enddate|dateFormat('DD/MM/YYYY')}}</div>
              <div
                style="position: absolute;right: 10px;bottom: 10px;color: #ff706b;font-weight: 600;font-size: 1.3em"
              >Point {{item.point | numberFormat}}</div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import selectCategory from './selectCategory.vue'
import Categories from './Categories'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    uploadfile,
    selectCategory,
    Multiselect,
    Categories
  },
  data() {
    return {
      deleteLoading: false,
      showstartdate: false,
      showenddate: false,
      input: {
        name: '',
        photourl: '',
        description: '',
        point: '',
        categoryid: '',
        quantity: '',
        startdate: '',
        enddate: ''
      },
      showAddReward: false,
      savecategoryloading: false,
      showCategory: false,
      categoryaddinput: '',
      addcategory: false,
      categorylist: [],
      rewardlist: [],
      selectedcategory: '',
      saveproductloading: false
    }
  },
  created() {},
  mounted() {
    this.getCategories()
    this.getRewards()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredStartdate() {
      if (this.input.startdate) {
        return moment(this.input.startdate).format('DD/MM/YYYY')
      } else return ''
    },
    filteredEnddate() {
      if (this.input.enddate) {
        return moment(this.input.enddate).format('DD/MM/YYYY')
      } else return ''
    },
    filteredProducts() {
      if (this.categorylist.length && this.rewardlist) {
        return this.rewardlist.filter(el => el.categoryid == this.selectedcategory)
      } else return []
    }
  },
  methods: {
    updateproduct() {
      var vm = this
      var data = { ...vm.input, categoryid: vm.input.categoryid.id, pageid: vm.selectedBot.pageid }
      vm.$validator.validateAll().then(result => {
        if (result) {
          vm.saveproductloading = true
          api.putsahapanrewardproducts(data, (err, response) => {
            vm.saveproductloading = false
            if (response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'แก้ไขสำเร็จ'
                })
                .then(() => {
                  var index = vm.rewardlist.findIndex(el => el.id == vm.input.id)
                  vm.$set(vm.rewardlist, index, data)
                  vm.closeform()
                })
            }
          })
        }
      })
    },
    closeform() {
      this.input = {
        name: '',
        photourl: '',
        description: '',
        point: '',
        categoryid: '',
        quantity: '',
        startdate: '',
        enddate: ''
      }
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
      this.showAddReward = false
    },
    editProduct(item) {
      var vm = this
      this.input = {
        ...item,
        categoryid: this.categorylist.find(el => el.id == item.categoryid),
        startdate: moment(item.startdate).format('YYYY-MM-DD'),
        enddate: moment(item.enddate).format('YYYY-MM-DD')
      }
      this.showAddReward = true
    },
    onChangeCategory(e) {
      this.selectedcategory = e
    },
    saveproduct() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (result) {
          vm.saveproductloading = true
          api.postsahapanrewardproducts(
            { ...vm.input, categoryid: vm.input.categoryid.id },
            (err, response) => {
              vm.saveproductloading = false
              if (response.responsecode == 200) {
                vm.$swal
                  .fire({
                    type: 'success',
                    text: 'เพิ่มสำเร็จ'
                  })
                  .then(() => {
                    vm.rewardlist.push({
                      ...vm.input,
                      id: response.data[0].id,
                      categoryid: vm.input.categoryid.id
                    })
                    vm.closeform()
                  })
              }
            }
          )
        }
      })
    },
    onCategoryChange: function() {
      let vm = this
    },
    getCategories() {
      var vm = this
      api.getsahapanrewardcategories((err, response) => {
        if (response.responsecode == 200) {
          if (response.data) {
            vm.categorylist = response.data
            vm.selectedcategory = response.data[0].id
          }
        }
      })
    },
    getRewards() {
      var vm = this
      api.getsahapanrewardproducts((err, response) => {
        if (response.responsecode == 200) {
          if (response.data) {
            vm.rewardlist = response.data
          }
        }
      })
    },
    deleteProduct(item) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        id: item.id
      }
      this.$swal
        .fire({
          text: 'คุณต้องการลบรายการนี้ใช่หรือไม่?',
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            vm.deleteLoading = true
            api.deletesahapanrewardproducts(data, (err, response) => {
              vm.deleteLoading = false
              if (response.responsecode == 200) {
                var index = vm.rewardlist.findIndex(el => el.id == item.id)
                vm.rewardlist.splice(index, 1)
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.category-box {
  min-height: 120px;
  border: 0.5px solid black;
}
.item-category {
  height: 50px;
  border: solid #ff706b 1px;
}
.add-product {
  height: 80px;
  border: dashed rgb(189, 189, 189) 1.2px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(189, 189, 189);
  cursor: pointer;
}
.add-product:hover {
  color: rgb(128, 128, 128);
  border: dashed rgb(128, 128, 128) 1.2px;
}
</style>


// WEBPACK FOOTER //
// src/components/view/template/sahapan/RewardManager.vue